import { render, staticRenderFns } from "./SortableItem.vue?vue&type=template&id=c5f1f1ba&scoped=true&"
import script from "./SortableItem.vue?vue&type=script&lang=js&"
export * from "./SortableItem.vue?vue&type=script&lang=js&"
import style0 from "./SortableItem.vue?vue&type=style&index=0&id=c5f1f1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f1f1ba",
  null
  
)

export default component.exports